import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./MeasuringDeviceFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";
import MeasuringDeviceFormStepOne from "./MeasuringDeviceFormSteps/MeasuringDeviceFormStepOne";

const MeasuringDeviceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        // ZAPYTAĆ NORBASA CZEMU TU BEZ VALUE NIE DZIAŁA
        // responsiblePerson: { value: _initialValues?.responsiblePerson?.uuid },
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="MeasuringDeviceForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <MeasuringDeviceFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default MeasuringDeviceForm;
